import './allRelatedAccountList.scss';
import React from 'react';
import { useState, useEffect } from 'react';
import UserAvatar from '../../../../common/businessCommon/user/userAvatar/userAvatar';
import UserName from '../../../../common/businessCommon/user/userName/userName';
import { deleteSwitchedAccount, getLoginedList } from '../../../../dataServices/authDataService';
import { IRelatedAccountInfo, IRelatedAccountList } from '../../../../interface/relatedAccount';
import If from '../../../../common/components/if';
import { getAccountName } from '../../../../services/authorizationService';
import { PlainText } from '../../../plainText/plainText';
import IUserInfo from '../../../../interface/userInfo';
import IEnterpriseInfo from '../../../../interface/enterpriseInfo';
import useSwitchAccount from '../../../../hooks/useSwitchAccount';
import { defaultAvatars } from '@umu/umu-util';

const [unsetEnterpriseDefaultAvatar] = defaultAvatars;
export interface IProps {
    userInfo: IUserInfo;
    lang: string;
    enterpriseInfo: IEnterpriseInfo;
}

export function AllRelatedAccountList(props: IProps) {
    const { userInfo, lang, enterpriseInfo } = props;
    const [accountList, setAccountList] = useState<IRelatedAccountList>({
        list: [],
        total: 0,
    });
    const [isAccountListLoading, setAccountListLoading] = useState(false);
    const [isDeleting, setDeleting] = useState(false);
    const { isSwitching, onSwitchAccount } = useSwitchAccount(lang);

    useEffect(() => {
        const load = async () => {
            const ret = await getLoginedList();
            if (ret?.data) {
                const curentAccount: IRelatedAccountInfo = {
                    avatar: userInfo.avatar,
                    user_name: userInfo.user_name,
                    enterprise_name: enterpriseInfo.enterprise_name || '',
                    account: getAccountName(userInfo),
                    user_token: '',
                    is_valid: 1,
                };
                const data = {
                    list: [curentAccount].concat(ret.data.list || []),
                    total: ret.data.total || 0,
                };
                setAccountList(Object.assign({}, data));
            }
            setAccountListLoading(false);
        };

        load();
    }, []);

    const onDeleteAccount = ($event, account) => {
        if (isDeleting) {
            return;
        }
        setDeleting(true);
        deleteSwitchedAccount(account.user_token).then((ret) => {
            if (ret.data) {
                const index = accountList.list.findIndex((item) => {
                    return item.user_token === account.user_token;
                });

                const list = accountList.list.concat([]);
                list.splice(index, 1);
                const total = accountList.total - 1;
                const data = {
                    list,
                    total,
                };

                setAccountList(Object.assign({}, data));
            }
            setDeleting(false);
        });
        $event.stopPropagation();
        $event.preventDefault();
        return false;
    };

    const renderItem = (item: IRelatedAccountInfo, index: number) => {
        return (
            <div className="account-item" onClick={() => onSwitchAccount(index === 0 ? null : item)}>
                <div className="account-item-wrap">
                    <If condition={index !== 0}>
                        <div className="account-item-actions" ng-if="!$first">
                            <a
                                href="javascript:"
                                className={`btn btn-optional ${isDeleting ? 'disabled' : ''}`}
                                onClick={(e) => {
                                    onDeleteAccount(e, item);
                                }}
                            >
                                <PlainText lang={lang}>删除</PlainText>
                            </a>
                            <a href="javascript:" className={`btn btn-primary ${isSwitching ? 'disabled' : ''}`}>
                                <PlainText lang={lang}>切换账户</PlainText>
                            </a>
                        </div>
                    </If>

                    <If condition={index === 0}>
                        <div className="is-current-account">
                            <PlainText lang={lang}>当前登录</PlainText>
                        </div>
                    </If>

                    <div className="account-item-avatar">
                        <UserAvatar
                            src={item.avatar || unsetEnterpriseDefaultAvatar}
                            className="data-user-avatar"
                            width={48}
                            showUserLevel={0}
                        />
                    </div>
                    <div className="account-item-info">
                        <div className="account-item-info-wrap">
                            <div className="account-item-info-name truncate-text">
                                <UserName
                                    name={item.user_name}
                                    className="data-user-name"
                                    showUserLevel={0}
                                    transcate={true}
                                />
                            </div>
                            <div className="account-item-info-display-account truncate-text">{item.account}</div>
                            <div className="account-item-info-enterprise-name truncate-text">
                                {item.enterprise_name}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="all-related-account-list">
            <div className="header">
                <PlainText lang={lang}>全部账户</PlainText>
            </div>
            <If condition={!isAccountListLoading}>
                <div className={`account-list ${isDeleting ? 'is-switching' : ''}`}>
                    {accountList.list.map((item, index) => {
                        return renderItem(item, index);
                    })}
                </div>
            </If>
        </div>
    );
}
